import React, { useState } from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import PromoButtonExtended from 'components/no-auth/common/promo-button/PromoButtonExtended';
import { PromoDiskButton } from 'components/no-auth/common/PromoDiskButton/PromoDiskButton';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';
import PromoIllustration from 'components/no-auth/common/widgets/Illustration/PromoIllustration';

import promoMedia from 'theme/promoMedia';

import HeadingSection from './HeadingSection';

const VideoContainer = styled.div`
    height: 0;
    padding-top: 56.3241%;
    position: relative;
    width: 100%;

    ${promoMedia.tablet744} {
        padding-top: 56.21%;
    }

    iframe {
        height: 100%;
        position: absolute;
        left: 0;
        max-height: 100%;
        max-width: 100%;
        top: 0;
        width: 100%;
    }
`;

const BtnContainer = styled.div`
    margin-top: 24px;
    text-align: center;

    ${promoMedia.tablet744} {
        margin-top: 48px;
    }

    ${promoMedia.desktop1440} {
        margin-top: 40px;
    }
`;
const VideoSection = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;

    ${promoMedia.tablet744} {
        max-width: 504px;
        padding-left: 120px;
        padding-right: 120px;
    }

    ${promoMedia.desktop1440} {
        max-width: 1080px;
        padding-left: 180px;
        padding-right: 180px;
    }
`;
const SectionContainer = styled.div`
    padding-top: ${(props) => (props.hasTopPadding ? '32px' : null)};
    padding-bottom: 32px;
    display: flex;
    flex-direction: column;

    ${promoMedia.tablet744} {
        padding-top: ${(props) => (props.hasTopPadding ? '48px' : null)};
        padding-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        padding-top: ${(props) => (props.hasTopPadding ? '64px' : null)};
        padding-bottom: 64px;
    }
`;
const TitleContainer = styled.div`
    order: ${(props) => (props.videoAtTop ? '2' : null)};
`;
const PlayButton = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
`;

const VideoSectionV2 = (props) => {
    const videoUrl = props.videoUrl + `?rel=0&amp;showinfo=0&amp;autoplay=1`;
    const [isShowVideo, setShowVideo] = useState(false);

    const toggleVideo = () => {
        setShowVideo(!isShowVideo);
    };

    return (
        <SectionContainer hasTopPadding={props.hasTopPadding}>
            {(props.sectionTitle || props.sectionText) && (
                <TitleContainer videoAtTop={props.videoAtTop}>
                    <PromoSectionContainer>
                        <HeadingSection title={props.sectionTitle} text={props.sectionText} noBottomIndent={props.videoAtTop} />
                    </PromoSectionContainer>
                </TitleContainer>
            )}
            {props.videoUrl && (
                <VideoSection>
                    {isShowVideo ? (
                        <VideoContainer>
                            <iframe
                                src={videoUrl}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                allow="autoplay; encrypted-media;accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen="1"
                                title={props.videoTitle}
                            />
                        </VideoContainer>
                    ) : (
                        <>
                            {props.videoPreviewImg && <PromoIllustration img={props.videoPreviewImg} loadingLazy />}
                            <PlayButton>
                                <PromoDiskButton
                                    type="button"
                                    variant="primary"
                                    iconName="play-button"
                                    size="large"
                                    onClick={toggleVideo}
                                    labelText={'Play video'}
                                />
                            </PlayButton>
                        </>
                    )}
                </VideoSection>
            )}
            {props.btn && (
                <PromoSectionContainer>
                    <BtnContainer>
                        <PromoButtonExtended btn={props.btn} btnMobile={props.btnMobile} isMobileBtn={props.isMobileBtn} iconName={props.iconName} />
                    </BtnContainer>
                </PromoSectionContainer>
            )}
        </SectionContainer>
    );
};
VideoSectionV2.propTypes = {
    videoUrl: PropTypes.string,
    videoTitle: PropTypes.string,
    sectionTitle: PropTypes.string,
    sectionText: PropTypes.string,
    btn: PropTypes.object,
    btnMobile: PropTypes.object,
    isMobileBtn: PropTypes.bool,
    hasTopPadding: PropTypes.bool,
    videoPreviewImg: PropTypes.array,
    videoAtTop: PropTypes.bool,
};
export default VideoSectionV2;
